import HomePage from './HomePage'
import MastHead from './masthead'
import Preamble from './preamble'
import CenterHead from './centerhead'

export{
	HomePage,
	MastHead,
	Preamble,
	CenterHead
}


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Home/components/index.js